import { Navigate, useLocation, useRouteError } from "react-router";

import { LegacyAuthDeniedError } from "../auth/legacy-auth-denied";
import { to } from "../to";

const LegacyAuthRedirectBoundary = () => {
  const error = useRouteError();
  const { search, hash } = useLocation();

  if (!(error instanceof LegacyAuthDeniedError)) {
    throw error;
  }

  return <Navigate replace to={{ pathname: to.login, search, hash }} />;
};

export { LegacyAuthRedirectBoundary };
